<template>
  <div class="home-page">
    <page-head class="page-top"></page-head>
    <div class="page-content">
      <left-bar-single v-if="path.indexOf('oil_chart') === -1 && path.indexOf('gas_map') === -1"></left-bar-single>
      <div class="right-content">
        <router-view></router-view>
      </div>
    </div>
    <loading></loading>
  </div>
</template>

<script>
import store from '@/store'
import LeftBarSingle from '@/components/LeftBarSingle'
import PageHead from '@/components/PageHead'
import Loading from '@/components_bit/Loading'
export default {
  beforeRouteEnter (to, from, next) {
    if (store.getters.logined !== 1) {
      store.dispatch('setLoginFor', 'single_home')
      next({name: 'login'})
    } else if (!store.getters.oilArea) {
      next({name: 'index'})
    } else {
      next()
    }
  },
  components: {
    LeftBarSingle,
    PageHead,
    loading: Loading
  },
  computed: {
    path: {
      get () {
        return this.$store.state.route.path
      }
    }
  }
}
</script>

<style scoped lang="less">
@import '../../style/base.less';
.page-top {
  z-index: 4;
}
.right-content::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// single_home.vue?7662f342